import React from 'react';
import { i18n_begin_your_journey_to_well_being } from '@yi/i18n/phrases/i18n_begin_your_journey_to_well_being';
import { i18n_start_your_free_trial } from '@yi/i18n/phrases/i18n_start_your_free_trial';

import { MEMBERSHIP_PATHNAME } from '~/src/common/routes';
import { useConvertedContentFrom } from '~/src/common/sign-up/converted-content-from';
import { useLocale } from '~/src/components/LocaleProvider';
import { LocalizedLink } from '~/src/components/LocalizedLink';

import { Container, H2, Button, ButtonWrapper } from './elements';

export const StartFreeTrialCTA: React.FC = () => {
  const { locale } = useLocale();
  const { addToUrlConvertedContentFrom } = useConvertedContentFrom();

  const url = addToUrlConvertedContentFrom({ targetUrl: MEMBERSHIP_PATHNAME });

  return (
    <Container>
      <H2>{i18n_begin_your_journey_to_well_being(locale)}</H2>
      <ButtonWrapper>
        <LocalizedLink to={url}>
          <Button aria-label="Start your free trial">{i18n_start_your_free_trial(locale)}</Button>
        </LocalizedLink>
      </ButtonWrapper>
    </Container>
  );
};
